import CrediqueOfferModal from '@/components/offers/CrediqueOfferModal.vue';

export default [
    {
        id: 'credique',
        component: CrediqueOfferModal,
        products: ['personal_loan'],
        // Not in the embeddable iframe: its modal uses the session-backed
        // /portal/credique/offer/* routes (see offerAvailableHere in useOfferCheck.js).
        iframe: false,
        conditions: (app, stepIndex, totalSteps) => {
            // console.log('stepIndex', stepIndex);
            // console.log('totalSteps', totalSteps);
            if(stepIndex >= 24) {
                return app?.unique_id && app?.projectBrandCountry === 'CA' && app.address?.province !== 'QC' && app?.completed_flinks === 'yes';
            }
            return false;
        },
    }
];
